import { Routes } from '@angular/router';
import { provideDiscoverDomain } from '@zero/discover/domain';
import { provideGuidedTourDomain } from '@zero/guided-tour/domain';
import { provideHomeDomain } from '@zero/home/domain';
import { provideLombardDomain } from '@zero/lombard/domain';
import { provideOnboardingDomain } from '@zero/onboarding/domain';
import { provideOrderDomain } from '@zero/order/domain';
import { provideSavingPlansDomain } from '@zero/saving-plans/domain';
import { CustomerGuard } from '@zero/shared/util-web-app-services';
import { provideStatisticsDomain } from '@zero/statistics/domain';
import { provideTagsDomain } from '@zero/tags/domain';
import { provideTradeDomain } from '@zero/trade/domain';

export const HOME_WEB_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home-page/home-page.component').then((m) => m.HomePageComponent),
    providers: [
      provideHomeDomain(),
      provideTradeDomain(),
      provideDiscoverDomain(),
      provideGuidedTourDomain(),
      provideLombardDomain(),
      provideOrderDomain(),
      provideStatisticsDomain(),
      provideTagsDomain(),
      provideSavingPlansDomain(),
      provideOnboardingDomain(),
    ],
  },
  {
    path: 'multi-order-strategien',
    canActivate: [CustomerGuard],
    loadComponent: () =>
      import('./pages/multi-order-strategies-landing-page/multi-order-strategies-landing-page.component').then(
        (m) => m.MultiOrderStrategiesLandingPageComponent,
      ),
    providers: [provideHomeDomain(), provideDiscoverDomain()],
  },
  {
    path: 'multi-order-strategien/:id',
    canActivate: [CustomerGuard],
    loadComponent: () =>
      import('./pages/multi-order-strategies-details-page/multi-order-strategies-details-page.component').then(
        (m) => m.MultiOrderStrategiesDetailsPageComponent,
      ),
    providers: [provideHomeDomain(), provideDiscoverDomain()],
  },
];
